<mat-dialog-content>
  <mat-legacy-card-title
    mat-legacy-dialog-title
    class="dialog-title"
    *ngIf="!resend"
  >
    <mat-icon>email</mat-icon>
    <span>{{ 'shared.send-request-popup.title' | translate }}</span>
  </mat-legacy-card-title>
  <mat-legacy-card-title
    mat-legacy-dialog-title
    class="dialog-title"
    *ngIf="resend"
  >
    <mat-icon>email</mat-icon>
    <span>{{ 'shared.send-request-popup.resend-title' | translate }}</span>
  </mat-legacy-card-title>
  <mat-card-subtitle class="dialog-subtitle">
    {{ 'shared.send-request-popup.subtitle' | translate }}
  </mat-card-subtitle>

  <mat-divider></mat-divider>

  <form [formGroup]="responseFormGroup" class="dialog-form">
    <mat-form-field appearance="fill" class="full-width-field">
      <mat-label>
        {{ 'shared.send-request-popup.additional-emails' | translate }}
      </mat-label>
      <mat-chip-grid #emailsChipList>
        <mat-chip-row
          *ngFor="let email of addedEmails"
          [selectable]="false"
          (removed)="removeEmail(email)"
        >
          {{ email }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
        <input
          placeholder="{{
            'shared.send-request-popup.additional-emails-placeholder'
              | translate
          }}"
          #emailInput
          formControlName="additionalEmails"
          [matChipInputFor]="emailsChipList"
          [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
          [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="
            addEmail(emailInput.value); emailInput.value = ''
          "
        />
      </mat-chip-grid>
      <mat-error
        *ngIf="
          responseFormGroup.controls.additionalEmails.hasError('email') ||
          emailValidationError
        "
      >
        {{
          'shared.send-request-popup.additional-emails.pattern-error'
            | translate
        }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width-field">
      <mat-label>
        {{ 'shared.send-request-popup.remarks' | translate }}
      </mat-label>
      <textarea
        data-testid="step-documents-description"
        matInput
        formControlName="remarks"
        placeholder="{{
          'shared.send-request-popup.remarks-placeholder' | translate
        }}"
        rows="3"
      ></textarea>
    </mat-form-field>

    <div *ngIf="!resend" class="share-section">
      <h6 class="share-title">
        {{ 'shared.send-request-popup.share-title' | translate }}
      </h6>
      <mat-card-subtitle class="share-subtitle">
        {{ 'shared.send-request-popup.share-subtitle' | translate }}
      </mat-card-subtitle>
      <mat-divider></mat-divider>
    </div>

    <div class="contacts-list">
      <!-- Send Contacts -->
      <div *ngFor="let contact of sendContacts" class="contact-item">
        <mat-checkbox [checked]="true" [disabled]="true"></mat-checkbox>
        <div class="contact-info">
          <div class="avatar-circle">
            <mat-icon>person</mat-icon>
          </div>
          <div class="contact-details">
            <p class="contact-name">{{ contact.name.first_name }}</p>
            <p class="contact-email">{{ getPrimaryEmail(contact.email) }}</p>
          </div>
        </div>
        <div class="contact-role">
          <p *ngIf="contact?.is_liaison_agent">
            {{ 'shared.send-request-popup.liaison-agent' | translate }}
          </p>
          <p *ngIf="!contact?.is_liaison_agent">
            {{ 'shared.send-request-popup.contact-person' | translate }}
          </p>
        </div>
      </div>

      <!-- Added Emails -->
      <div *ngFor="let email of addedEmails" class="contact-item">
        <mat-checkbox [checked]="true" [disabled]="true"></mat-checkbox>
        <div class="contact-info">
          <div class="avatar-circle">
            <mat-icon>person</mat-icon>
          </div>
          <div class="contact-details">
            <p class="contact-name">{{ email }}</p>
          </div>
        </div>
        <div class="contact-role">
          <p>{{ 'shared.send-request-popup.contact-person' | translate }}</p>
        </div>
      </div>

      <!-- Handlers -->
      <div *ngFor="let handler of handlers; let i = index" class="contact-item">
        <mat-checkbox
          (change)="onHandlerCheckboxChange(i, $event.checked)"
        ></mat-checkbox>
        <div class="contact-info">
          <div class="avatar-circle">
            <mat-icon>person</mat-icon>
          </div>
          <div class="contact-details">
            <p class="contact-name">{{ getArrangedName(handler.name) }}</p>
            <p class="contact-email">{{ handler.email }}</p>
          </div>
        </div>
        <div class="contact-role">
          <p>
            {{
              handler?.isClaimHandler
                ? ('claims.create.claim-handler' | translate)
                : ('claims.create.account-handler' | translate)
            }}
          </p>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="onClickClose()">
    {{ 'shared.send-request-popup.cancel' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="outputData()"
    [disabled]="responseFormGroup.invalid"
  >
    {{ 'shared.send-request-popup.send' | translate }}
  </button>
</mat-dialog-actions>
